<template lang="pug">
app-modal(v-model="visible" :title="title" :width="500" :confirm-loading="loading" @ok="handleSubmit" @cancel="hide")
  app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="90")
  
    a-form-model-item(label="产品" prop="productId" )        
      a-input(:value="model.productDTO ? model.productDTO.name : ''" disabled)

    a-form-model-item(label="客户订单号" prop="customerOrderCode" )
      a-input(v-model="model.customerOrderCode" allow-clear :max-length="100" placeholder="请输入客户订单号")
  
    a-form-model-item(label="产品备注" prop="productComments" )
      a-textarea(v-model="model.productComments" allow-clear :min="0" placeholder="请输入库存数量")
            
        
</template>

<script>
import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';
export default {
  name: 'CreateAndEdit',
  components: {},
  data() {
    return {
      visible: false,
      loading: false,
      title: '添加库存',
      model: {
        customerOrderCode: null,
        productComments: null,
      },
      rules: {
        // customerOrderCode: [{ required: true, message: '必填项' }],
      },
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
      };
    },
  },
  mounted() {},
  methods: {
    show(model, action) {
      // this.$refs.form.resetFields();
      this.model = {
        ...this.model,
        ...model,
      };
      this.action = action;
      this.title = model === undefined ? '添加库存' : '编辑库存';
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.$refs.form.resetFields();
      this.model = {
        productId: null,
        customer: null,
        warehouseId: null,
        warehousePartitionId: null,
        quantity: null,
      };
      // this.$refs.item.handleCancel();
    },
    async handleSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        this.loading = true;
        this.$restful(`save:/prj/inventory`, {
          ...this.model,
          projectId: this.project.id,
        })
          .then(() => {
            this.$message.success(this.title + '成功!');
            this.$emit('modal-success');
            this.hide();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleInspTypeChange() {
      this.model.targetKeys = null;
    },
    handleDleteItem(itemId) {
      this.model.rmItemIds.push(itemId);
    },
    handleClickAddItem() {
      this.$refs.form.clearValidate(['itemDTOS']);
    },
  },
};
</script>

<style lang="less" scoped>
.checkbox-item {
  padding-left: 90px;
  margin: -10px 0 16px 0;
}
.insp-item-list {
}
</style>
